import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { User } from 'src/app/core/authentication/User';
import { UserProfile } from 'src/app/core/authentication/UserProfile';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-workshop-center-header',
  templateUrl: './workshop-center-header.component.html',
  styleUrls: ['./workshop-center-header.component.scss']
})
export class WorkshopCenterHeaderComponent implements OnInit {

  @ViewChild("anchor", { static: false })
  public anchor: ElementRef<HTMLElement>;
  
  userWorkshopProfile: UserProfile;
  user: User;
  showUserMenu: boolean;
  profileReferenceType:string;

  sessionValidTime: Date;
  currentTime: Date;
  brand:string;
  isTrainingEnv:boolean;

  constructor(private authService: AuthService, 
    private router: Router) {
      this.brand = environment.brand;
      this.isTrainingEnv = environment.isTrainingEnv;
  }

  ngOnInit(): void {
    this.user = this.authService.getLoggedUserInfo();
    this.userWorkshopProfile = this.user.getLoggedUserProfile(ReferenceType.Workshop);
    this.sessionValidTime = this.authService.tokenExpirationTime();
    this.currentTime = new Date();

    //if empty root retrieved dispatch-profile
    if(this.router.url == '/'){
      this.router.navigate(['dispatch-profile']);
    }
  }

  logoutUser(): void {
    this.authService.logout();
  }

  showUserProfile(){
    this.showUserMenu = true;
  }
}
